import { Box } from '@chakra-ui/react';
import { FC } from 'react';

export const SizeLimiter: FC = ({ children }) => {
  return <Box margin="0 auto" maxW={980}>{children}</Box>;
};
